function resume() {

	var genError = "An unexpected error popped up. Please try again.";
	var view = {

		setEventListeners: function() {
            var domain = $('#domain').val();

            // clear any old cookies on load
            POP.clearCookies();

            // watch for form submission
			$('#resumeForm').submit($.proxy(this, 'submitResumeForm'));

            // if the domain is already populated, submit!
            if (domain.length > 2) {
                $('#resumeForm').trigger('submit');
            }
		},

		submitResumeForm: function(e) {
			var $form = $(e.target);

			e.preventDefault();

            this.submitForm($form, '/register/resume/', 'registrationResumeHandler');
		},

		registrationResumeHandler: function(response) {
            var $alert = $('#resumeForm .alert');

            void 0;

            POP.Message.response($alert, response);
            POP.scrollTo($alert, true);

			if (response.code == 200) {
                $.cookie('pop_domain', response.data.domain, { path:'/', domain:'.pop.co' });
                $.cookie('pop_domain_id', response.data.domain_id, { path: '/', domain: '.pop.co' });
				$.cookie('pop_email', response.data.firstname.toLowerCase() + '@' + response.data.domain, { path:'/', domain:'.pop.co' });
				
				// set valid session cookies
				$.cookie('pop_weasel', resp.data.token, { path: '/', domain: '.pop.co' });
				
                // send to percolator
				window.location.href = '/panel/?onboard';
			}
		},

		submitForm: function($form, url, handler) {
			var data = $form.serialize(),
                $btn = $form.find('button[type=submit]'),
                $alert = $form.find('.alert');

            POP.Message.hide($alert);
			POP.Ajax.submitting($btn);

			$.ajax({
				type: "POST",
				url: POP.apiBaseUrl + url,
				data: data,
				success: $.proxy(this, handler),
				error: $.proxy(function() {
                    POP.Message.response($alert, {msg: POP.messages.genericError});
                    POP.Ajax.error($btn);
                }, this),
				headers: {'X-Requested-With': 'XMLHttpRequest'},
				crossDomain: true,
				dataType: "json"
			}).done(function() {
                POP.Ajax.done($btn);
            });
		}
	};

	function start() {
		view.setEventListeners();
		$('[type=text]').eq(0).focus();
	}

	start();

}
